module.exports = __webpack_public_path__ + "img/the-serif.32f76f5d.png";